import { useBadgeData } from './useBadgeCounts';

export const STEP_SUBMISSION_REQUESTS_QUERY_KEY = ['step-submission-requests'];
export const STEP_SUBMISSION_REQUESTS_COUNT_QUERY_KEY = ['step-submission-requests', 'count'];

/** Pending workflow step-submission request count for the sidebar badge (shared /badge-counts poll). */
export function useStepSubmissionCount() {
  return useBadgeData().data?.step_submissions ?? 0;
}
